/**
 * O endereço que não existe, para quem JÁ ESTÁ dentro do sistema.
 *
 * Existe porque o contrário era pior: o roteador mandava qualquer endereço
 * desconhecido para `/entrar`, e clicar num link para uma tela que ainda não
 * foi construída parecia queda de sessão — a pessoa via o login e concluía que
 * tinha sido desconectada no meio do trabalho.
 *
 * A tela não pede desculpa nem enfeita: diz qual endereço não existe (é o que
 * a pessoa vai repetir para quem for ajudar) e oferece os dois caminhos que
 * sempre servem — voltar e ir para o começo.
 */
import { useLocation, useNavigate } from 'react-router-dom'

import { Botao, LinkBotao } from '../../componentes/Botao'
import { Icone } from '../../componentes/Icone'

export function TelaNaoEncontrada() {
  const local = useLocation()
  const navegar = useNavigate()

  return (
    <div className="flex min-h-screen items-center justify-center bg-fundo px-6">
      <div className="flex max-w-[460px] flex-col items-center gap-3 text-center">
        <span className="flex h-12 w-12 items-center justify-center rounded-sistema bg-divisoria">
          <Icone nome="error" tamanho={24} className="text-texto-suave" />
        </span>

        <h1 className="font-titulo text-[20px] font-bold text-titulo">Este endereço não existe</h1>
        <p className="text-[13.5px] leading-[1.55] text-texto-suave">
          Nada foi perdido e sua sessão continua aberta — o caminho é que não leva a lugar nenhum.
        </p>
        <p className="tabular rounded-sistema bg-superficie px-3 py-2 text-[12.5px] break-all text-texto">
          {local.pathname}
        </p>

        <div className="mt-1 flex flex-wrap items-center justify-center gap-2.5">
          <Botao variante="secundario" icone="arrow_back" onClick={() => navegar(-1)}>
              Voltar
            </Botao>
          <LinkBotao para="/app">Ir para o início</LinkBotao>
        </div>
      </div>
    </div>
  )
}
